export default "__VITE_ASSET__BITsNVYU__"